const map = {
	"./logo-calendly.webp": 68316,
	"./logo-highlevel.webp": 96296,
	"./logo-mailchimp.webp": 3252,
	"./logo-mailgun.webp": 31421,
	"./logo-maps.webp": 27785,
	"./logo-pipedrive.webp": 27262,
	"./logo-quickbooks.webp": 46437,
	"./logo-roposo.webp": 91438,
	"./logo-stripe.webp": 79411,
	"./logo-twilio.webp": 18926,
	"./logo-zoom.webp": 5165
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20948;